module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "shaded m-5",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.form.name.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Name\n                    "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                        *\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }, _vm.$v.form.name.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Code\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('h5', {
    staticClass: "mt-5"
  }, [_vm._v("PRICES - PVP")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.taxes) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.taxes,
      "placeholder": "- Select tax -",
      "searchable": true,
      "label": "description"
    },
    on: {
      "input": _vm.updateVatTypes
    },
    model: {
      value: (_vm.selectedVatType),
      callback: function($$v) {
        _vm.selectedVatType = $$v
      },
      expression: "selectedVatType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 d-flex align-items-center"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.prices[0].priceIncludeTaxes),
      callback: function($$v) {
        _vm.$set(_vm.form.prices[0], "priceIncludeTaxes", $$v)
      },
      expression: "form.prices[0].priceIncludeTaxes"
    }
  }, [_vm._v("\n                Price with taxes\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.form.prices), function(price, index) {
    return _c('div', {
      staticClass: "row mb-2"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (price.value),
        expression: "price.value"
      }],
      staticClass: "glued-right w-100",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (price.value)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(price, "value", $event.target.value)
        }, _vm.$v.form.prices.$each[index].$touch]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "glued-left",
      class: {
        'color-6': _vm.$v.form.prices.$each[index].value.$error
      }
    }, [_vm._v("€")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_vm._m(1, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (price.name),
        expression: "price.name"
      }],
      class: {
        'border-color-6': _vm.$v.form.prices.$each[index].name.$error
      },
      attrs: {
        "type": "text",
        "placeholder": "PVP Name"
      },
      domProps: {
        "value": (price.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(price, "name", $event.target.value)
        }, _vm.$v.form.prices.$each[index].$touch]
      }
    })]), _vm._v(" "), (_vm.form.prices.length > 1) ? _c('div', {
      staticClass: "col-sm-2 d-flex align-items-center"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('i', {
      staticClass: "ico ico-delete m-0 fs-large medium pointer",
      on: {
        "click": function($event) {
          return _vm.removePrice(index)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 color-6"
    }, [(_vm.$v.form.prices.$each[index].$error) ? _c('div', {
      staticClass: "messages"
    }, [(_vm.$v.form.prices.$each[index].value.$error) ? _c('span', [_vm._v("Price is required.")]) : _vm._e(), _vm._v(" "), (_vm.$v.form.prices.$each[index].name.$error) ? _c('span', [_vm._v("Label is required.")]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold my-3"
  }, [_c('span', {
    on: {
      "click": _vm.addPrice
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" New PVP\n                ")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                Additional description\n                "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    attrs: {
      "placeholder": "e.g. Alert for high temperatures."
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "italic fs-smaller dark mt-2"
  }, [_vm._v("This message is public and is shown on the booking screen.")])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group row pt-4"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "d-flex pb-1"
  }, [_vm._v("\n                    Allow commission fee\n                    "), _c('toggle-button', {
    staticClass: "ml-auto",
    attrs: {
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.form.allowCommissionFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "allowCommissionFee", $$v)
      },
      expression: "form.allowCommissionFee"
    }
  })], 1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Price\n                        "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                            *\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Label\n                        "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                            *\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("\n                Advanced options\n                "), _c('div', {
    staticClass: "fs-small normal mt-2 mb-3"
  }, [_vm._v("Set options for reservations with this extra.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-54193c58", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54193c58"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/extras/ExtraForm.vue
// module id = 967
// module chunks = 0